import LearningPathway from './LearningPathway'
export default LearningPathway; 